/**
 * Collection List Slider Navigation + Manual Pagination Handler
 */
const initCollectionSliderArrows = () => {
    if (window.innerWidth <= 768) return;
const sections = document.querySelectorAll(".collection-list-slider");

  sections.forEach((section) => {
    const swiperElem = section.querySelector(".swiper");
    const nextBtn = section.querySelector(".swiper-button-next");
    const prevBtn = section.querySelector(".swiper-button-prev");
    const paginationEl = section.querySelector(".swiper-pagination");

    if (!swiperElem || !nextBtn || !prevBtn || !paginationEl) return;
    if (section.dataset.sliderBound === "true") return;

    const bindSwiperControls = () => {
      const swiper = swiperElem.swiper;
      if (!swiper) return false;

      const getRealSlideCount = () => {
        if (swiper.snapGrid && swiper.snapGrid.length) {
          return swiper.snapGrid.length;
        }

        if (swiper.slides && swiper.params.slidesPerView) {
          const totalSlides = swiper.slides.length;
          const perView = Number(swiper.params.slidesPerView) || 1;
          return Math.max(1, totalSlides - perView + 1);
        }

        return 1;
      };

      const renderBullets = () => {
        const bulletCount = getRealSlideCount();
        paginationEl.innerHTML = "";

        for (let i = 0; i < bulletCount; i++) {
          const bullet = document.createElement("button");
          bullet.type = "button";
          bullet.className = "manual-swiper-bullet";
          bullet.setAttribute("aria-label", `Go to slide ${i + 1}`);

          bullet.addEventListener("click", () => {
            swiper.slideTo(i);
          });

          paginationEl.appendChild(bullet);
        }

        updateBullets();
      };

      const updateBullets = () => {
        const bullets = paginationEl.querySelectorAll(".manual-swiper-bullet");
        if (!bullets.length) return;

        bullets.forEach((bullet, index) => {
          bullet.classList.toggle("is-active", index === swiper.snapIndex);
        });
      };

      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        swiper.slideNext();
      });

      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        swiper.slidePrev();
      });

      swiper.on("slideChange", updateBullets);
      swiper.on("snapIndexChange", updateBullets);
      swiper.on("resize", () => {
        renderBullets();
      });
      swiper.on("update", () => {
        renderBullets();
      });

      renderBullets();

      section.dataset.sliderBound = "true";
      return true;
    };

    if (!bindSwiperControls()) {
      let tries = 0;
      const maxTries = 60;

      const waitForSwiper = setInterval(() => {
        tries += 1;

        if (bindSwiperControls() || tries >= maxTries) {
          clearInterval(waitForSwiper);
        }
      }, 200);
    }
  });
};

document.addEventListener("DOMContentLoaded", initCollectionSliderArrows);
document.addEventListener("shopify:section:load", initCollectionSliderArrows);
window.addEventListener("load", initCollectionSliderArrows);
